var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Power component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconPower extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 1.10522C12.4142 1.10522 12.75 1.44101 12.75 1.85522V10.4372C12.75 10.8514 12.4142 11.1872 12 11.1872C11.5858 11.1872 11.25 10.8514 11.25 10.4372V1.85522C11.25 1.44101 11.5858 1.10522 12 1.10522Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.34947 3.5468C6.60437 3.87329 6.54634 4.3446 6.21984 4.5995C4.67827 5.80304 3.55086 7.45778 2.9949 9.33283C2.43895 11.2079 2.48219 13.2097 3.11859 15.059C3.75499 16.9083 4.95281 18.5128 6.54491 19.6487C8.13701 20.7845 10.044 21.395 11.9997 21.395C13.9555 21.395 15.8624 20.7845 17.4545 19.6487C19.0466 18.5128 20.2444 16.9083 20.8808 15.059C21.5172 13.2097 21.5605 11.2079 21.0045 9.33283C20.4486 7.45778 19.3212 5.80304 17.7796 4.5995C17.4531 4.3446 17.395 3.87329 17.65 3.5468C17.9049 3.2203 18.3762 3.16226 18.7027 3.41716C20.4904 4.81291 21.7979 6.73192 22.4426 8.90643C23.0874 11.0809 23.0372 13.4025 22.2992 15.5471C21.5612 17.6918 20.172 19.5525 18.3257 20.8698C16.4793 22.187 14.2678 22.895 11.9997 22.895C9.73163 22.895 7.52012 22.187 5.67375 20.8698C3.82738 19.5525 2.43827 17.6918 1.70023 15.5471C0.962188 13.4025 0.912041 11.0809 1.55679 8.90643C2.20153 6.73192 3.509 4.81291 5.29676 3.41716C5.62326 3.16226 6.09457 3.2203 6.34947 3.5468Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconPower.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconPower.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconPower.prototype, "size", void 0);
if (customElements.get('cat-icon-power') === undefined) {
    customElements.define('cat-icon-power', BlocksIconPower);
}
